import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import CardSliderLogin from "../components/login/cardSliderLogin";
import LoginForm from "../components/login/loginForm";
import logo from "../assets/image/logo.png";

export default function Login() {
  const lg = useMediaQuery("(max-width:850px)");
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="left"
      bgcolor="white"
      width="100vw"
      height="100vh"
      position="fixed"
    >
      <Box height="100%" width="100%">
        <Box m="30px" display={"flex"} alignItems="center" gap="30px">
          <img style={{ width: "100px", height: "auto" }} src={logo} />
          <Typography
            fontSize="22px"
            fontWeight="bold"
            marginInlineStart={"20px"}
          >
            {" اثر"}
          </Typography>
        </Box>
        <Box display="grid" alignItems={"center"} height="auto">
          <LoginForm lg={lg} />
        </Box>
      </Box>
      {!lg && (
        <Box
          className="cardLogin"
          style={{
            background: "linear-gradient(180deg, #6cbbc7 0%, #6cbbc7 100%)",
          }}
          ml="14px"
        >
          <CardSliderLogin />
        </Box>
      )}
    </Box>
  );
}
